export default `float s=2., e;
    for(int i=0;i++<7;){
      p.xz=.8-abs(p.xz);
      p.x < p.z?p=p.zyx:p;
      s*=e=2.1/min(dot(p,p),1.);
      p=abs(p)*e-vec3(1.0,18.0,9.0);
    }
    return length(p)/s-0.01;
  }`